export default defineNuxtRouteMiddleware(() => {
  if (import.meta.server) return

  const authUser = useState<any>('authUser')
  const allowedRoles = ['Administrator', 'HospitalAdmin']
  if (!allowedRoles.includes(authUser.value?.roleName)) {
    return navigateTo('/patientDesign')
  }
})
